import axios from "axios";

const BASE_URL = "https://food.totalfresh.co/public/api/v2/admin";

export const getAuthToken    = () => localStorage.getItem("auth_token");
export const getProfile    = () => JSON.parse(localStorage.getItem("profile"));
export const getRememberToken = () => localStorage.getItem("remember_token");

export const setAuthToken    = (token) => localStorage.setItem("auth_token", token);
export const setRememberToken = (token) => localStorage.setItem("remember_token", token);
export const setProfile = (data) => localStorage.setItem("profile", JSON.stringify(data));

export const clearAuthToken  = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("profile");
}
export const clearAllTokens  = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("remember_token");
};

export const getUserRole = () => {
    try {
        const profile = JSON.parse(localStorage.getItem("profile"));
        const roles   = profile?.roles || [];

        const priorityRoles = [
            "admin",
            "manager",
            "order_manager",
            "field_manager",
            "customer_feedback",
        ];

        // normalize: lowercase + spaces → underscores
        const normalizedRoles = roles.map(role =>
            String(role).toLowerCase().replace(/\s+/g, "_")
        );

        const matchedRole = priorityRoles.find(role =>
            normalizedRoles.includes(role)
        );

        return matchedRole || null;

    } catch (error) {
        console.error("Failed to get user role:", error);
        return null;
    }
};



const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        Accept: "application/json",
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const token = getAuthToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.data instanceof FormData) {
            delete config.headers["Content-Type"];
        } else {
            config.headers["Content-Type"] = "application/json";
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default apiClient;